/**
 * @generated SignedSource<<f7e22758aaca56f29521c5b6fcb0cd11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnifiedGamificationBadgeCategory = "COURSE" | "LEARNING_PATH" | "%future added value";
export type ProfileBadgesQuery$variables = {
  internalId?: string | null;
  username?: string | null;
};
export type ProfileBadgesQuery$data = {
  readonly unified: {
    readonly unifiedProfile: {
      readonly aaid?: string | null;
      readonly badges?: {
        readonly edges?: ReadonlyArray<{
          readonly node: {
            readonly actionUrl: string | null;
            readonly description: string | null;
            readonly id: string;
            readonly imageUrl: string | null;
            readonly lastCompletedDate: string | null;
            readonly name: string | null;
            readonly type: string | null;
          } | null;
        } | null> | null;
        readonly extensions?: ReadonlyArray<{
          readonly errorType: string | null;
          readonly statusCode: number | null;
        }> | null;
        readonly identifier?: string | null;
        readonly message?: string | null;
        readonly totalCount?: number | null;
      } | null;
      readonly extensions?: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly id?: string;
      readonly identifier?: string | null;
      readonly isProfileOwnerConsented?: boolean | null;
      readonly learning?: {
        readonly extensions?: ReadonlyArray<{
          readonly errorType: string | null;
          readonly statusCode: number | null;
        }> | null;
        readonly id?: string;
        readonly identifier?: string | null;
        readonly message?: string | null;
        readonly recentLearningAchievementBadges?: {
          readonly edges?: ReadonlyArray<{
            readonly node: {
              readonly actionUrl: string | null;
              readonly category: UnifiedGamificationBadgeCategory | null;
              readonly description: string | null;
              readonly id: string;
              readonly imageUrl: string | null;
              readonly lastCompletedDate: string | null;
              readonly name: string | null;
              readonly type: string | null;
            } | null;
          } | null> | null;
          readonly totalCount?: number | null;
        } | null;
      } | null;
      readonly message?: string | null;
    } | null;
  } | null;
};
export type ProfileBadgesQuery = {
  response: ProfileBadgesQuery$data;
  variables: ProfileBadgesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "internalId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "internalId"
  },
  {
    "kind": "Variable",
    "name": "unifiedProfileUsername",
    "variableName": "username"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aaid",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProfileOwnerConsented",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastCompletedDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedProfileBadgeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnifiedProfileBadge",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v8/*: any*/),
            (v4/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "category",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v13/*: any*/)
  ],
  "type": "UnifiedProfileBadgesConnection",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedProfileBadgeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnifiedProfileBadge",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v8/*: any*/),
            (v4/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v13/*: any*/)
  ],
  "type": "UnifiedProfileBadgesConnection",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileBadgesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "learning",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "recentLearningAchievementBadges",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UnifiedLearning",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "badges",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProfileBadgesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "learning",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "recentLearningAchievementBadges",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UnifiedLearning",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "badges",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v15/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc0c5cc70de05e055caaa96d092fd49a",
    "id": null,
    "metadata": {},
    "name": "ProfileBadgesQuery",
    "operationKind": "query",
    "text": "query ProfileBadgesQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n      ... on UnifiedProfile {\n        id\n        aaid\n        isProfileOwnerConsented\n        learning {\n          __typename\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n          ... on UnifiedLearning {\n            id\n            recentLearningAchievementBadges {\n              __typename\n              ... on UnifiedProfileBadgesConnection {\n                edges {\n                  node {\n                    actionUrl\n                    description\n                    id\n                    imageUrl\n                    lastCompletedDate\n                    name\n                    type\n                    category\n                  }\n                }\n                totalCount\n              }\n            }\n          }\n        }\n        badges {\n          __typename\n          ... on UnifiedProfileBadgesConnection {\n            edges {\n              node {\n                actionUrl\n                description\n                id\n                imageUrl\n                lastCompletedDate\n                name\n                type\n              }\n            }\n            totalCount\n          }\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7b072436cd022bad9475618b88894a0";

export default node;
